import { render, staticRenderFns } from "./FactorCreator.vue?vue&type=template&id=a3a9b504&scoped=true&"
import script from "./FactorCreator.vue?vue&type=script&lang=ts&"
export * from "./FactorCreator.vue?vue&type=script&lang=ts&"
import style0 from "./FactorCreator.vue?vue&type=style&index=0&id=a3a9b504&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a9b504",
  null
  
)

export default component.exports